import { render, staticRenderFns } from "./PerformanceTargetExceptionEditor.vue?vue&type=template&id=96e8573a"
import script from "./PerformanceTargetExceptionEditor.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetExceptionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports